import * as types from "actions/customers/actionTypes";

const initialState = {
  error: null
};

export const CustomersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CUSTOMER_CREATE_SUCCESS:
    case types.CUSTOMER_UPDATE_SUCCESS:
    case types.CUSTOMER_DELETE_SUCCESS:
      return {
        ...state,
        error: null
      };
    case types.CUSTOMER_CREATE_ERROR:
    case types.CUSTOMER_UPDATE_ERROR:
    case types.CUSTOMER_DELETE_ERROR:
      return {
        ...state,
        error: action.error.message
      };

    default:
      return state;
  }
};

export default CustomersReducer;
